import { render, staticRenderFns } from "./edit-booking-skeleton.vue?vue&type=template&id=c3bdd624&scoped=true&"
import script from "./edit-booking-skeleton.vue?vue&type=script&lang=js&"
export * from "./edit-booking-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./edit-booking-skeleton.vue?vue&type=style&index=0&id=c3bdd624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bdd624",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCol,VContainer,VRow,VSkeletonLoader})
